import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { Router, ActivatedRoute } from "@angular/router";


import { IPurchase, Purchase } from "./../../shared/models/purchase";
import { Exam, IExam } from "./../../shared/models/products/exam";
import { ExamAddOn } from "./../../shared/models/products/exam-addon";
import {
  ExamPayment,
  ExamPaymentDetail,
} from "./../../shared/models/payments/exam-payment";
import { PurchaseService } from "./../../shared/services/purchase.service";
import { PurchaseStateService } from "./../../shared/services/purchase-state.service";
import { UserService } from "../../../shared/services/user.service";

import { Profile } from "./../../../practitioner/shared/models/profile";
import { RegexPatterns } from "./../../../shared/regex/regex-patterns";
import { MinimumDOBValidator } from "./../shared/dobValidator";
import { AppSettingsService } from "./../../../shared/services/app-settings.service";
import { NotificationsService } from "./../../../shared/services/notifications.service";
import { ViewStateService } from "./../../../shared/services/view-state.service";
import { CommonApiService } from "./../../../shared/services/api/common-api.service";
import { IProduct } from "../../shared/models/products/product";
import { PractitionerService } from "app/practitioner/shared/services/practitioner.service";
import { Subject } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";
import { environment } from "environments/environment";

enum CardTypes {
  Amex,
  Discover,
  MasterCard,
  Visa,
}

declare let Accept: any;

@Component({
  selector: "app-exam",
  templateUrl: "./exam.component.html",
})
export class ExamComponent implements OnInit, OnDestroy {
  purchase: IPurchase = new Purchase(this.userService);
  checkoutForm: UntypedFormGroup;
  DOBForm: UntypedFormGroup;
  DemographicForm: UntypedFormGroup;

  profile: Profile;
  demographics: any;

  //showTerms1: boolean;
  //showTerms2: boolean;
  collectDiscipline: boolean;
  disciplineLov: any[];
  validDiscipline=false;
  disciplineAudit=false;
  collectBirthday: boolean;
  collectDemographics: boolean;
  reinstatementFee: boolean;
  timeLimitEndDate: boolean;
  expirationDate: boolean;
  recertificationFlag=false;
  licensureExam=false;
  
  showEligDates: boolean;
  showWaitMessage: boolean;

  serverMessage: string;
  examInstructions: string;
  examNameFortimeLimit = "Clinical Simulation Examination";
  cardTypes = CardTypes;
  ccType: CardTypes;
  personId = "";
  exam: Exam;
  countries: any;
  waitAlert = false;
  waitMessage: any;

  inValidPayment = true;
  isPaymentProcessing = false;

  paymentType: string;
  onDestroy$ = new Subject();
  isProcessing = false;
  freeServiceExpiration: Date;

  constructor(
    private userService: UserService,
    private purchaseState: PurchaseStateService,
    private purchaseService: PurchaseService,
    private commonApiService: CommonApiService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private appSettings: AppSettingsService,
    private notificationsService: NotificationsService,
    private viewState: ViewStateService,
    private route: ActivatedRoute,
    private practitionerService: PractitionerService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();

    const examCode = this.route.snapshot.params["examCode"];
    this.collectBirthday = this.route.snapshot.params["collectDOB"] ?? false;
    this.collectDemographics =
      this.route.snapshot.params["collectDemographics"];
    this.collectDiscipline =
      this.route.snapshot.params["collectDiscipline"];
    this.reinstatementFee = this.route.snapshot.params["reinstatementFee"];
    const personId = this.userService.CurrentUser.personId;
    this.personId = personId;
    if(this.collectDiscipline) {
      this.getDisciplines();
    }

    if (!examCode || !personId) {
      this.viewState.stopLoading();
      this.router.navigate([""]);
      return;
    }
    
    this.createExamPurchase(examCode, personId);

    this.buildForm();
    this.setupFormListeners();
    this.getCountries();

    this.purchaseService
      .getProfile(this.userService.CurrentUser.personId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        const profile = <Profile>res;
        this.purchaseState.setPractitionerName(
          profile.firstName.concat(" ").concat(profile.lastName)
        );
        this.formValues.address = profile.line1;
        this.formValues.nameOnCard = profile.firstName
          .concat(" ")
          .concat(profile.lastName);
        this.formValues.city = profile.city;
        this.formValues.state = profile.stateProvince;
        this.formValues.zip = profile.zip;
        this.formValues.countryId = profile.countryId.toString();

        this.checkoutForm.patchValue(this.formValues);

        this.viewState.stopLoading();
      });

      this.purchaseService
        .loadAcceptJs()
        .then(() => {
          console.log("Accept.js is ready");
        })
        .catch((err) => {
          console.error(err);
        });


    this.checkoutForm.controls["cardNumber"].valueChanges
      .pipe(debounceTime(500), takeUntil(this.onDestroy$))
      .subscribe((v: string) => {
        if (v.match("^4[0-9]{12}(?:[0-9]{3})?$")) {
          this.ccType = CardTypes.Visa;
        } else if (
          v.match(
            "^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$"
          )
        ) {
          this.ccType = CardTypes.MasterCard;
        } else if (v.match("^3[47][0-9]{13}$")) {
          this.ccType = CardTypes.Amex;
        } else if (v.match("^6(?:011|5[0-9]{2})[0-9]{12}$")) {
          this.ccType = CardTypes.Discover;
        } else {
          this.ccType = null;
        }
      });
  }

  private getProfileDetails() {
    if (this.personId) {
      this.practitionerService
        .getDemographics(this.personId.toString())
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((details) => {
          this.profile = details;
          if (!details.race) {details.race = "";}
          if (!details.gender) {details.gender = "";}
          if (!details.spanishOrigin) {details.spanishOrigin = "";}
          this.demographics = details;
          this.DemographicForm.patchValue(this.demographics);
          this.viewState.stopLoading();
        });
    }
  }

  private createExamPurchase(examCode: string, personId: string) {
    this.purchaseService
      .getExamApplicationInfo(personId, examCode, true)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((examInfo) => {
        const exam = this.createExam(examInfo);
        this.updateFlags(exam, examInfo);
        if(examInfo.cost == 0) 
          {this.paymentType="FREE";}
        if(examInfo.freeServiceExpiration)
          {this.freeServiceExpiration = examInfo.freeServiceExpiration;}
        //this.updateTermsVisibility(exam.code);
        this.fetchAndApplyProfileDetails(personId);
      });
  }

  private createExam(examInfo: any): Exam {
    const exam = new Exam();
    exam.price = examInfo.cost;
    exam.code = examInfo.examCode;
    exam.title = examInfo.examName;
    exam.examId = examInfo.examID;
    exam.serviceCodeId = examInfo.serviceCodeId;
    exam.quantity = 1;
    exam.applicationId = examInfo.applicationId;
    exam.personId = this.userService.CurrentUser.personId;
    exam.collectBirthday = this.collectBirthday;
    exam.collectDemographics = this.collectDemographics;
    exam.collectDiscipline = this.collectDiscipline;
    exam.reinstatementFee = this.reinstatementFee;
    exam.examInstructions = examInfo.examInstructions;
    exam.timeLimitEndDate = examInfo.timeLimitEndDate;
    exam.expirationDate = examInfo.expirationDate;
    exam.eligibilityBeginDate = examInfo.eligibilityBeginDate;
    exam.eligibilityEndDate = examInfo.eligibilityEndDate;
    exam.isSubjectToWait = examInfo.isSubjectToWait;
    exam.schedulingLink = examInfo.schedulingLink;    
    this.waitMessage = examInfo.waitMessage;
    this.timeLimitEndDate =
      examInfo.timeLimitEndDate &&
      examInfo.examName == this.examNameFortimeLimit
        ? true
        : false;
    this.showEligDates = !!examInfo.eligibilityBeginDate;
    this.showWaitMessage = examInfo.isSubjectToWait;
    this.expirationDate = !!examInfo.expirationDate;
    this.exam = exam;
    this.purchase.products.push(exam);
    return exam;
  }

  private updateFlags(exam: Exam, examInfo: any) {

    if (exam.collectDiscipline === "false") {
      this.collectDiscipline=false;
    } else {
      this.collectDiscipline=true;
    }

    if (exam.collectBirthday === "false") {
      this.collectBirthday = false;
    } else {
      this.collectBirthday = true;
    }

    if (exam.collectDemographics === "false") {
      this.collectDemographics = false;
    } else {
      this.collectDemographics = true;
      this.getProfileDetails();
    }

    if (exam.reinstatementFee === "false") {
      this.reinstatementFee = false;
    } else {
      this.reinstatementFee = true;
    }
    if (examInfo.applicationStatusCode=="CC1"){
      this.recertificationFlag = true;
    }
    if (examInfo.applicationStatusCode=="CL" || examInfo.applicationStatusCode=="CLR") {
      this.licensureExam = true;
    }

  }

  private fetchAndApplyProfileDetails(personId: string) {
    this.purchaseService
      .getProfile(personId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((profile: Profile) => {
        this.purchase.practitionerName = `${profile.firstName} ${profile.lastName}`;
        this.formValues.address = profile.line1;
        this.formValues.nameOnCard = `${profile.firstName} ${profile.lastName}`;
        this.formValues.city = profile.city;
        this.formValues.state = profile.stateProvince;
        this.formValues.zip = profile.zip;
        this.formValues.countryId = profile.countryId.toString();
        this.checkoutForm.patchValue(this.formValues);
        this.viewState.stopLoading();
      });
  }

  /* private updateTermsVisibility(examCode: string) {
    switch (examCode) {
      case "TMC":
      case "CSE":
        this.showTerms1 = true;
        break;
      case "ACCS":
      case "NPS":
      case "PFT":
      case "SDS":
      case "AE-C":
        this.showTerms2 = true;
        break;
      default:
        this.showTerms1 = false;
        this.showTerms2 = false;
        break;
    }
  } */

  setWaitAlert() {
    const dtEligDate = new Date(this.exam.eligibilityBeginDate);
    let eligDate: string;
    eligDate =
      dtEligDate.getMonth().toString() +
      "/" +
      dtEligDate.getDate().toString() +
      "/" +
      dtEligDate.getFullYear().toString();
    this.waitAlert = true;
    this.purchaseService
      .sendWaitNotice(this.personId, this.exam.examId, eligDate)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (res) => {
          this.notificationsService.error(
            "Warning",
            "Due to wait period after number of attempts you will not be able to test before your credential or TMC time limit expires.  You will need to reapply as a new candidate after " +
              dtEligDate.toLocaleDateString()
          );
        },
        (err) => {}
      );
  }

  showShortTYTLWarning() {
    if (this.timeLimitEndDate) {
      const dtEligDate = new Date(this.exam.eligibilityBeginDate);
      const dtTimeLimit = new Date(this.exam.timeLimitEndDate);
      return dtEligDate <= dtTimeLimit;
    } else {return false;}
  }

  showExpirationWarning() {
    if (this.exam.expirationDate) {return true;}
    else {return false;}
  }

   private submitPaymentInitial() {
          const authData = {
            clientKey: environment.clientKey,
            apiLoginID: environment.apiLogin,
          };
      
          const cardData = {
            cardNumber: this.formValues.cardNumber,
            month: this.formValues.expirationDate.substring(0, 2),
            year: 20 + this.formValues.expirationDate.substring(2),
            cardCode: this.formValues.ccv,
          };
      
          const secureData = {
            authData,
            cardData,
          };
          //console.log(authData);
          //console.log(cardData);
      
          Accept.dispatchData(secureData, this.responseHandler.bind(this));
        }
      
        responseHandler(response: any) {
          if (response.messages.resultCode === "Error") {
            console.error(
              "Error creating payment nonce/token:",
              response.messages.message
            );
            console.log(response.messages);
            let err = response.messages.message[0].text;
            if (!err || err=="") 
              {err = "Please review credit card information and resubmit";}
            this.notificationsService.error(
              "Payment Failed",
              err
            );        
            this.isPaymentProcessing=false;
            this.viewState.stopLoading();
            return;
          }
      
          const opaqueData = response.opaqueData;
          
          this.submitPayment(opaqueData);
        }

  onSubmit(updatedForm) {
    this.isPaymentProcessing = true;
    this.formValues = updatedForm;
    const validForm = !this.validateForm(this.checkoutForm);

    if (this.checkoutForm.valid && validForm) {
      this.viewState.startLoading();
      if (this.paymentType=="CC") {
          this.submitPaymentInitial();
      } else {
        const opaqueData = {dataValue: "", datDescriptor: ""};
        this.submitPayment(opaqueData);
      }
    } else {
      this.isPaymentProcessing = false;
    }
  }

  private submitPayment(opaqueData) {
      const examProduct = <Exam>this.purchase.products[0];
      const paymentParams = this.mapPurchaseToPayment(examProduct, opaqueData);
      this.purchase.paymentMethod = paymentParams.paymentType;
      this.purchase.paymentDate = new Date();

      // If there are exam addon's
      if (this.purchase.products[1]) {
        const examProductAddOn = <ExamAddOn>this.purchase.products[1];
        paymentParams.details.push(
          this.addPurchaseAddOnToPayment(examProductAddOn)
        );
      }
      if (this.purchase.products[2]) {
        const examProductAddOn = <ExamAddOn>this.purchase.products[2];
        paymentParams.details.push(
          this.addPurchaseAddOnToPayment(examProductAddOn)
        );
      }

      this.purchaseService
        .sendExamPayment(paymentParams)
        .pipe(take(1), takeUntil(this.onDestroy$))
        .subscribe(
          (res) => {
            this.isPaymentProcessing = false;

            //examProduct.schedulingLink = res.schedulingLink;
            //examProduct.eligibilityEndDate = res.eligibilityEndDate;
            this.purchaseState.setCompletedPurchase(this.purchase);
            this.purchase = new Purchase(this.userService);

            this.viewState.stopLoading();
            this.router.navigate(["purchase/checkout/confirmation"]);
          },
          (e) => {
            this.isPaymentProcessing = false;

            this.handleServerErrorResponse(e);
          }
        );
  }

  onCancel(event: Event) {
    event.preventDefault();
    this.isPaymentProcessing=false;
    this.purchase = new Purchase(this.userService);
    this.router.navigate([""]);
  }

  submitDOB() {
    this.isProcessing=true;
    this.viewState.startLoading();
    this.validateForm(this.DOBForm);
    if (this.DOBForm.valid) {
      this.purchaseService
        .updateDateOfBirth(this.personId, this.DOBForm.get("dob").value)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (res) => {
            this.viewState.stopLoading();
            this.collectBirthday = false;
            this.isProcessing=false;
            this.notificationsService.success(
              "Success",
              "Your date of birth has been updated. You may now purchase the exam."
            );
          },
          (error) => {
            this.isProcessing=false;
            this.viewState.stopLoading();
            this.notificationsService.error(
              "Failed",
              "Your date of birth was not updated."
            );
          }
        );
    } else {
      this.viewState.stopLoading();
      this.isProcessing=false;
    }
  }

  submitDemoGraphic() {
    this.isProcessing=true;
    this.validateForm(this.DemographicForm);
    if (this.DemographicForm.valid) {
      this.practitionerService
        .updateDemographics(
          this.personId.toString(),
          this.DemographicForm.value
        )
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (resp) => {
            this.viewState.stopLoading();
            this.isProcessing=false;
            this.notificationsService.success(
              "Success",
              "The demographic responses have been updated."
            );
            this.collectDemographics = false;
          },
          (errors) => {
            this.isProcessing=false;
            this.notificationsService.error(
              "Failed",
              "The demographic responses have not been updated."
            );
            this.mapServerErrorsToForm(errors.error);
            this.viewState.stopLoading();
          }
        );
    } else {
      this.viewState.stopLoading();
      this.isProcessing=false;
    }
  }

  submitDiscipline() {
    this.isProcessing=true;
    if (this.validDiscipline) {
      this.practitionerService
        .updateDiscipline(
          this.personId.toString(),
          this.disciplinePicked
        )
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (resp) => {
            this.viewState.stopLoading();
            this.isProcessing=false;
            this.notificationsService.success(
              "Success",
              "The discipline responses has been updated."
            );
            if (resp.auditRequired) {
              this.disciplineAudit=true;
            }
            this.collectDiscipline = false;
          },
          (errors) => {
            this.isProcessing=false;
            this.notificationsService.error(
              "Failed",
              "The discipline responses have not been updated."
            );
            this.mapServerErrorsToForm(errors.error);
            this.viewState.stopLoading();
          }
        );
    } else {
      this.viewState.stopLoading();
      this.isProcessing=false;
    }
  }

  private getCountries() {
    this.commonApiService
      .getCountries()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (res) => {
          this.countries = res;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  private getDisciplines() {
    this.commonApiService
    .getLov('DISCIPLINE')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (res) => {
        this.disciplineLov= res;
      },
      (error) => {
        console.log(error);
      }
    );
  }

/*   onDisciplineChange(event) {
    this.disciplinePicked();
  }
 */
  get disciplinePicked() {
    const pick = this.checkoutForm.get("discipline").value;
    if (["1","2","3","6","7","8","9","10","12","13"].includes(pick) )
       {this.validDiscipline=true;}
    else {this.validDiscipline=false;}
    return pick;
  }


  private handleServerErrorResponse(response) {
    if (response.status === 500) {
      this.notificationsService.error(
        "Unexpected Error",
        "An unexpected error occurred."
      );
      if (!this.appSettings.IsProductionMode) {
        console.log(response);
      }
    } else {
      this.mapServerErrorsToForm(response.error);
    }
    this.viewState.stopLoading();
  }

  private mapServerErrorsToForm(errors) {
    const unknownErrors = [];
    let firstErrorFieldName;

    for (const error of errors) {
      this.formErrors[error.fieldName] = "";

      const control = this.checkoutForm.get(error.fieldName);
      if (control) {
        if (!firstErrorFieldName) {
          firstErrorFieldName = error.fieldName;
        }
        this.formErrors[error.fieldName] += error.message + " ";
      } else {
        unknownErrors.push(error.message);
      }
    }

    if (!errors || errors.message) {
      this.serverMessage = errors ? errors.message : null;
    } else if (unknownErrors.length > 0) {
      this.serverMessage = unknownErrors.join(" ");
    }

    if (!this.serverMessage) {
      this.serverMessage =
        "Your transaction could not be processed. Please try again or contact NBRC.";
    }
    this.isPaymentProcessing=false;
    this.viewState.stopLoading();

    this.notificationsService.error(
      "Payment Failed",
      "Your transaction was not processed. Please check your payment information and try again or contact NBRC."
    );

    setTimeout(function () {
      const target = <HTMLElement>(
        (document.getElementById(firstErrorFieldName)
          ? document.getElementById(firstErrorFieldName)
          : document.getElementById("serverMessage"))
      );
      console.log(target);
      target.scrollIntoView();
    }, 750);
  }

  private mapPurchaseToPayment(examProduct: IExam, opaqueData) {
    const paymentDetail = new ExamPaymentDetail();
    paymentDetail.cost = examProduct.price;
    paymentDetail.serviceCodeID = examProduct.serviceCodeId;
    paymentDetail.quantity = examProduct.quantity;

    const payment = new ExamPayment();
    payment.internationalTesting = false; //as of 2024 we no longer charge extra for international testing //this.formValues.internationalTesting;
    payment.details.push(paymentDetail);
    payment.applicationId = examProduct.applicationId;
    payment.personId = examProduct.personId;
    payment.specialAccomodations = this.formValues.specialAccommodations;
    payment.totalCost = this.purchase.total;

    if (this.paymentType == "V") {
      payment.paymentType = "V";
      payment.voucher = this.formValues.voucher;
    } else if (this.paymentType == "FREE" ) {
      payment.paymentType = "FREE";
    } else if (this.paymentType == "CC") {
      payment.paymentType = "CC";
      payment.address = this.formValues.address;
      payment.cardCode = ""; //this.formValues.ccv;
      payment.cardNumber = ""; //this.formValues.cardNumber;
      payment.city = this.formValues.city;
      payment.countryId = this.formValues.countryId;
      payment.expirationDate = ""; //this.formValues.expirationDate.replace("/", "");
      payment.payerName = this.formValues.nameOnCard;
      payment.state = this.formValues.state;
      payment.zip = this.formValues.zip;
      payment.dataDescriptor = opaqueData.dataDescriptor;
      payment.dataValue = opaqueData.dataValue;
    } else if (this.paymentType == "ACH") {
      payment.paymentType = "ACH";
      payment.payerName = this.formValues.nameOnAccount;
      payment.accountNumber = this.formValues.accountNumber;
      payment.routingNumber = this.formValues.routingNumber;
      payment.accountType = this.formValues.accountType;
      payment.nameOnAccount = this.formValues.nameOnAccount;
      payment.payerName = this.formValues.nameOnAccount;
    }

    return payment;
  }

  private addPurchaseAddOnToPayment(examAddOn: ExamAddOn) {
    const paymentDetail = new ExamPaymentDetail();
    paymentDetail.cost = examAddOn.price;
    paymentDetail.serviceCodeID = examAddOn.serviceCodeId;
    paymentDetail.quantity = examAddOn.quantity;
    return paymentDetail;
  }

  private buildForm() {
    this.DOBForm = this.formBuilder.group({
      dob: [
        this.formValues.dob,
        [Validators.required, MinimumDOBValidator.minimumAge(18)],
      ],
    });
    this.DemographicForm = this.formBuilder.group({
      gender: [this.demographicFormValues.gender, Validators.required],
      spanishOrigin: [
        this.demographicFormValues.spanishOrigin,
        Validators.required,
      ],
      race: [this.demographicFormValues.race, Validators.required],
    });

    this.checkoutForm = this.formBuilder.group({
      paymentOption: [this.formValues.paymentOption],
      specialAccommodations: [this.formValues.specialAccommodations],
      nameOnCard: [this.formValues.nameOnCard],
      cardNumber: [
        this.formValues.cardNumber,
        [
          Validators.minLength(15),
          Validators.pattern(RegexPatterns.integersOnly),
        ],
      ],
      expirationDate: [this.formValues.expirationDate],
      ccv: [
        this.formValues.ccv,
        [
          Validators.minLength(3),
          Validators.pattern(RegexPatterns.integersOnly),
        ],
      ],
      countryId: [this.formValues.countryId, Validators.required],
      address: [this.formValues.address],
      city: [this.formValues.city],
      state: [this.formValues.state],
      zip: [this.formValues.zip],
      voucher: [this.formValues.voucher],
      internationalTesting: [this.formValues.internationalTesting],
      paymentType: [this.formValues.paymentType, []],
      accountType: [this.formValues.accountType, []],
      routingNumber: [this.formValues.accountType, []],
      accountNumber: [this.formValues.accountType, []],
      routingNumberConfirm: [this.formValues.accountType, []],
      accountNumberConfirm: [this.formValues.accountType, []],
      nameOnAccount: [this.formValues.accountType, []],
      discipline: [this.formValues.discipline, []]
    });
  }

  private isVoucherPayment(paymentOption: string) {
    return paymentOption === "voucher";
  }

  private setupFormListeners() {
    //this.checkoutForm.get('paymentOption').valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(this.enablePaymentControls.bind(this));
    this.checkoutForm
      .get("internationalTesting")!
      .valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe(this.internationalTestingFlag.bind(this));
  }

  private enablePaymentControls(paymentOption: string) {
    const controlsToEnable = this.isVoucherPayment(paymentOption)
      ? this.voucherControls
      : this.ccControls;
    const controlsToDisable = this.isVoucherPayment(paymentOption)
      ? this.ccControls
      : this.voucherControls;

    controlsToEnable.forEach((name) => {
      this.checkoutForm.get(name).enable();
    });

    controlsToDisable.forEach((name) => {
      this.checkoutForm.get(name).disable();
    });
  }

  private internationalTestingFlag(internationalTest: boolean) {
    // this is the time to insert the international detail
    const paymentDetail = new ExamAddOn();
    paymentDetail.price = 150;
    paymentDetail.code = "INTNL";
    paymentDetail.title = "International Testing Fee";
    paymentDetail.serviceCodeId = 85;
    paymentDetail.quantity = 1;

    if (internationalTest) {this.patchProducts(paymentDetail);}
    else {this.removeProduct(paymentDetail);}
  }

  private checkReinstatment(reinstatementFee: boolean) {
    // this is the time to insert the reinstatment detail
    const paymentDetail = new ExamAddOn();
    paymentDetail.price = 150;
    paymentDetail.code = "EREINSTATE";
    paymentDetail.title = "Reinstatement Fee";
    paymentDetail.serviceCodeId = 87;
    paymentDetail.quantity = 1;

    if (reinstatementFee) {this.patchProducts(paymentDetail);}
    else {this.removeProduct(paymentDetail);}
  }

  private patchProducts(product: IProduct) {
    const index = this.purchase.products.findIndex(
      (p) => p.code === product.code
    );
    if (index > -1) {
      this.purchase.products.splice(index, 1, product);
      return;
    }
    this.purchase.products.push(product);
  }

  private removeProduct(product: IProduct) {
    const index = this.purchase.products.findIndex(
      (p) => p.code === product.code
    );
    if (index > -1) {
      this.purchase.products.splice(index, 1);
      return;
    }
  }

  private validateForm(form: UntypedFormGroup) {
    this.serverMessage = null;

    for (const control in form.controls) {
      form.controls[control].updateValueAndValidity();
    }

    let hasErrors = false;
    let hasACHErrors = false;
    for (const field in this.formErrors) {
      this.formErrors[field] = "";
      const control = form.get(field);
      if (control && control.invalid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + " ";
        }
      }
    }
    if (!this.paymentType) {
      this.formErrors["paymentType"] = "Payment method is required.";
      hasErrors = true;
    }
    if (this.paymentType == "ACH") {
      hasACHErrors = this.validateMatches();
    }
    if (hasErrors || hasACHErrors) {
      this.viewState.stopLoading();
      hasErrors = true;
    }
    return hasErrors;
  }

  public isInvalidPayment() {
    if (this.paymentType == "ACH") {
      if (
        this.checkoutForm.value.accountNumber == "" ||
        this.checkoutForm.value.accountNumberConfirm == "" ||
        this.checkoutForm.value.routingNumber == "" ||
        this.checkoutForm.value.routingNumberConfirm == "" ||
        this.checkoutForm.value.nameOnAccount == "" ||
        this.checkoutForm.value.accountType == ""
      )
        {this.inValidPayment = true;}
      else {
        this.inValidPayment = false;
      }
    } else if (this.paymentType == "CC") {
      if (
        this.checkoutForm.value.nameOnCard == "" ||
        this.checkoutForm.value.cardNumber == ""
      ) {
        this.inValidPayment = true;
      } else {
        this.inValidPayment = false;
      }
    } else {
      this.inValidPayment = true;
    }
    return this.inValidPayment;
  }

  private validateMatches() {
    let hasErrors = false;
    if (this.formValues.accountNumber != this.formValues.accountNumberConfirm) {
      this.formErrors["accountNumberConfirm"] = "account number must match";
      hasErrors = true;
    }
    if (this.formValues.routingNumber != this.formValues.routingNumberConfirm) {
      this.formErrors["routingNumberConfirm"] = "routing number must match";
      hasErrors = true;
    }
    return hasErrors;
  }

  formErrors = {
    paymentOption: "",
    specialAccommodations: "",
    internationalTesting: "",
    nameOnCard: "",
    cardNumber: "",
    expirationDate: "",
    ccv: "",
    countryId: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    voucher: "",
    dob: "",
    gender: "",
    spanishOrigin: "",
    race: "",
    accountType: "",
    routingNumber: "",
    accountNumber: "",
    routingNumberConfirm: "",
    accountNumberConfirm: "",
    nameOnAccount: "",
    paymentType: "",
  };

  private validationMessages = {
    paymentOption: {
      required: "Payment Options is required.",
    },
    specialAccommodations: {
      requiredIf: "Special Accommodations is required.",
    },
    nameOnCard: {
      requiredIf: "Name on Card is required.",
    },
    countryId: {
      required: "Country is required.",
    },
    cardNumber: {
      requiredIf: "Card Number is required.",
      minlength: "Card Number is invalid.",
      pattern: "Card Number is invalid.",
    },
    expirationDate: {
      requiredIf: "Expiration is required.",
    },
    ccv: {
      requiredIf: "CCV is required.",
      minlength: "CCV is invalid.",
      pattern: "CCV is invalid.",
    },
    address: {
      requiredIf: "Address is required.",
    },
    city: {
      requiredIf: "City is required.",
    },
    state: {
      requiredIf: "State is required.",
    },
    zip: {
      requiredIf: "Postal Code is required.",
    },
    voucher: {
      requiredIf: "Voucher Number is required.",
    },
    dob: {
      required: "Date of Birth is required.",
      requiredAge: "Must be at least 18 years of age.",
    },
    gender: {
      required: "Response required.",
    },
    race: {
      required: "Response required.",
    },
    spanishOrigin: {
      required: "Response required.",
    },
    routingNumber: {
      requiredIf: "Routing Number is required.",
      minlength: "Routing Number is invalid.",
    },
    routingNumberConfirm: {
      requiredIf: "Re-enter routing number.",
      minlength: "Routing Number is invalid.",
    },
    accountNumber: {
      requiredIf: "Account Number is required.",
      minlength: "Account Number is invalid.",
    },
    accountNumberConfirm: {
      requiredIf: "Re-enter account number.",
      minlength: "Account Number is invalid.",
    },
    accountType: {
      requiredIf: "Account type is required.",
      minlength: "Account type is invalid.",
    },
    nameOnAccount: {
      requiredIf: "Name on account is required.",
      minlength: "Name on account is invalid.",
    },
    paymentType: {
      required: "Payment method required.",
    },
  };

  private formValues = {
    paymentOption: "cc",
    specialAccommodations: false,
    internationalTesting: false,
    nameOnCard: "",
    cardNumber: "",
    expirationDate: "",
    ccv: "",
    countryId: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    voucher: "",
    dob: "",
    paymentType: "",
    routingNumber: "",
    routingNumberConfirm: "",
    accountType: "",
    accountNumber: "",
    accountNumberConfirm: "",
    nameOnAccount: "",
    discipline: ""
  };

  private ccControls = [
    "specialAccommodations",
    "internationalTesting",
    "nameOnCard",
    "cardNumber",
    "expirationDate",
    "ccv",
    "address",
    "city",
    "state",
    "zip",
  ];

  private voucherControls = ["voucher"];

  private demographicFormValues = {
    gender: "",
    spanishOrigin: "",
    race: "",
  };

  public changePaymentType(paymentType) {
    if (this.paymentType != paymentType) {
      //reset
      if (paymentType == "CH") {
        this.formValues.nameOnCard = null;
        this.formValues.cardNumber = null;
        this.formValues.expirationDate = null;
        this.formValues.ccv = null;
        this.formValues.city = null;
        this.formValues.state = null;
        this.formValues.zip = null;
      }
      this.paymentType = paymentType;
      this.checkoutForm.patchValue(this.formValues);
    }
    this.paymentType = paymentType;
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
